<template>
  <div class="SingleVine">
    <div class="vld-parent">
      <loading
        :active.sync="isLoading"
        :can-cancel="true"
        :is-full-page="fullPage"
        color="#018389"
        loader="dots"
      ></loading>
    </div>
    <div class="Actions__Content">
      <v-container fluid style="padding-top: 10px; padding-bottom: 10px">
        <Breadcrumbs />
        <!-- /.Breadcrumbs -->

        <section class="TankRoom">
          <h2 v-if="this.wine_item !== undefined">
            {{ this.wine_item.wineLabel.name + " " + this.wine_item.year }}
          </h2>
          <div class="VineYear__Content">
            <div class="VineYear__Content__Vine">
              <div class="VineBox">
                <div class="VineBox__Img">
                  <img id="wineimg"
                    v-bind:src="slika"
                    @error="
                      slika = slika_error
                    "
                    alt="Boca Vina"
                  />
                </div>
                <!-- /.VineBox__Img -->
                <div class="VineBox__Title">
                  <p v-if="this.wine_item !== undefined">
                    {{ this.wine_item.wineLabel.bottleVolumeInLiters }} l
                    <!-- <button @click="submit_izmena_slike" style="height:15px;width:15px;float: right; margin-right: 3px;">
                  <img
                    :src="`../assets/Ikone/icons8-edit-24_bela.png`"
                    alt="icon"
                    title="Izmena slike vina"
                  />
                </button> -->
                  </p>
                </div>
              </div>
              <div class="TankDetails" style="width: 24px; padding: 0px">
                <button @click="submit_izmena_slike" style="padding-top: 220px">
                  <img
                    :src="`../assets/Ikone/icons8-edit-24_bela.png`"
                    alt="icon"
                    title="Izmena slike vina"
                  />
                </button>
              </div>
              <!-- /.VineBox -->

              <!-- <div class="VineYears">
                <span v-for="item in items.wines" :key="item.id">
                  <router-link
                    :to="{ name: 'single_wine', params: { id: item.id } }"
                    class="columnRightVineType"
                  >
                    {{ item.year }}
                  </router-link>
                </span>
              </div> -->
              <!-- /.VineYears -->
            </div>
            <!-- /.VineYear__Content__Vine -->
            <div class="TankDetails">
              <div class="TankDetails__Item">
                <span class="label">Alkohol:</span>
                <span class="value" v-if="this.wine_item !== undefined"
                  >{{
                    this.wine_item.alcohol !== null
                      ? this.wine_item.alcohol
                      : "-"
                  }}
                  % vol.</span
                >
              </div>
              <div class="TankDetails__Item">
                <span class="label">Slobodni SO2:</span>
                <span class="value" v-if="this.wine_item !== undefined"
                  >{{
                    this.wine_item.freeSulfates !== null
                      ? this.wine_item.freeSulfates
                      : "-"
                  }}
                  g/hl</span
                >
              </div>
              <div class="TankDetails__Item">
                <span class="label">Ukupni SO2:</span>
                <span class="value" v-if="this.wine_item !== undefined"
                  >{{
                    this.wine_item.totalSulfates !== null
                      ? this.wine_item.totalSulfates
                      : "-"
                  }}
                  g/hl</span
                >
              </div>
              <div class="TankDetails__Item">
                <span class="label">Rezidualni šećer:</span>
                <span class="value" v-if="this.wine_item !== undefined"
                  >{{
                    this.wine_item.residualSugar !== null
                      ? this.wine_item.residualSugar
                      : "-"
                  }}
                  g/l</span
                >
              </div>
              <div class="TankDetails__Item">
                <span class="label">Ukupno kiselina:</span>
                <span class="value" v-if="this.wine_item !== undefined"
                  >{{
                    this.wine_item.totalAcid !== null
                      ? this.wine_item.totalAcid
                      : "-"
                  }}
                  g/l</span
                >
              </div>
              <div class="TankDetails__Item">
                <span class="label">Ph:</span>
                <span class="value" v-if="this.wine_item !== undefined">{{
                  this.wine_item.ph !== null ? this.wine_item.ph : "-"
                }}</span>
              </div>
              <div class="TankDetails__Item" v-if="administrator">
                <span class="label">Trošak proizvodnje:</span>
                <span v-if="this.cena !== ''" class="value"
                  >{{ this.cena }}
                  <button
                    @click="submit_parameterGrafic()"
                    style="padding-left: 15px"
                    v-if="this.cena !== '0,00 RSD' && this.cena !== '0 RSD' && this.cena !== '-'"
                  >
                    <img
                      :src="`../assets/Ikone/icons8-increase-24_bela.png`"
                      alt="icon"
                      title="Grafik strukture troškova proizvodnje vina"
                    />
                  </button>
                </span>
                <!-- <span v-else class="value"
                  ><a
                    v-on:click="cenaKostanja()"
                    style="color: rgb(1, 131, 137)"
                    v-bind:title="'Troškovi proizvodnje uključuju samo troškove grožđa, repromaterijala i ambalaže.\nOperacija izračunavanja troškova proizvodnje vina je veoma zahtevna operacija i može trajati nešto duže.'"
                    >Izračunaj</a
                  ></span
                > -->
              </div>
            </div>
            <div class="TankDetails">
              <div class="TankDetails__Item" style="height: 100%">
                <span class="label" style="width: 70px; vertical-align: top"
                  >Opis:</span
                >
                <span
                  class="value"
                  style="
                    width: 95% !important;
                    height: 90% !important;
                    border: solid 1px #dedede;
                    padding-left: 5px;
                    padding-right: 5px;
                  "
                  v-if="this.wine_item !== undefined"
                  >{{ this.wine_item.description }}</span
                >
              </div>
              <span class="label"></span>
            </div>
            <div>
              <span class="label">
                <button @click="submit_izmena" style="padding-top: 5px">
                  <img
                    :src="`../assets/Ikone/icons8-edit-24_bela.png`"
                    alt="icon"
                    title="Izmena podataka o vinu"
                  />
                </button>
              </span>
            </div>
          </div>
          <!-- /.VineYear__Content -->
        </section>
      </v-container>
    </div>
    <!-- /.Actions__Content -->

    <v-container
      fluid
      style="
        padding-top: 0px;
        padding-bottom: 10px;
        padding-left: 0px;
        padding-right: 0px;
      "
    >
      <v-layout row style="padding-left: 57px; padding-right: 57px">
        <v-flex xs12 style="overflow: auto">
          <v-data-table
            :headers="headers"
            :items="items_state_table"
            hide-actions
            class="elevation-1"
            style="padding: 3px"
          >
            <template slot="headers" slot-scope="props">
              <tr>
                <th
                  v-for="header in props.headers"
                  :key="header.text"
                  :class="[
                    'column',
                    '',
                    '',
                    header.align === 'left'
                      ? 'text-xs-left'
                      : header.align === 'right'
                      ? 'text-xs-right'
                      : 'text-xs-center',
                  ]"
                >
                  {{ header.text }}
                </th>
              </tr>
            </template>

            <template slot="items" slot-scope="props">
              <tr>
                <td style="text-align: center">
                  {{ props.item.lot }}
                </td>
                <td style="text-align: center">
                  <a
                    v-for="item in props.item.tanks"
                    :key="item.tankPhaseWineId"
                    class="columnRightVineType"
                    style="font-weight: bold; padding-right: 5px"
                    v-on:click="
                      routerLinkToDetails(
                        item.tankPhaseWineId,
                        item.tankId,
                        item.active
                      )
                    "
                  >
                    {{ item.tank }}
                  </a>
                </td>
                <td style="text-align: right">
                  {{ currencyFormatDE(props.item.bottling) }}
                </td>
                <td style="text-align: right">
                  {{ currencyFormatDE(props.item.warehouseState) }}
                </td>
                <td style="text-align: right">
                  {{ currencyFormatDE(props.item.output) }}
                </td>
                <td style="text-align: right">
                  {{ currencyFormatDE(props.item.writeOff) }}
                </td>
                <td style="text-align: right">
                  {{ currencyFormatDE(props.item.selling) }}
                </td>
                <td style="text-align: right">
                  {{ currencyFormatDEdec(props.item.sellingValue) }}
                </td>
                <template v-if="props.item.tanks !== undefined">
                  <td
                    v-if="props.item.tanks.length > 0"
                    style="text-align: right !important"
                  >
                    <img
                      style="vertical-align: middle !important"
                      class="DataTable__Button"
                      title="Grafik sastava flaširanog vina"
                      src="../assets/icons/zatabele/pai-chart-32_white.png"
                      alt="ulaz-grozdja"
                      @click="getGraficData(props.item)"
                    />
                  </td>
                  <td v-else></td>
                </template>
                <template v-else> </template>
              </tr>
            </template>
            <template slot="no-data">
              <!-- <v-btn color="primary" @click="initialize">Reset</v-btn> -->
              <v-alert slot="no-results" :value="true" color="error" icon="info"
                >Nema podataka.</v-alert
              >
            </template>
            <v-alert
              slot="no-results"
              :value="true"
              color="error"
              icon="warning"
              >Nema podataka.</v-alert
            >
          </v-data-table>
        </v-flex>
      </v-layout>
      <!-- <v-layout
        row
        style="
          padding-left: 10px;
          padding-right: 10px;
          padding-top: 0px;
          padding-bottom: 0px;
        "
      >
        <v-flex
          style="
            text-align: center;
            padding-right: 0px;
            padding-left: 20px;
            width: 16%;
          "
          ></v-flex
        >
        <v-flex
          style="
            text-align: center;
            padding-right: 0px;
            padding-left: 20px;
            width: 14%;
          "
          >Ukupno:</v-flex
        >
        <v-flex
          style="
            text-align: right;
            padding-left: 0px;
            padding-right: 10px;
            width: 14%;
          "
          >{{ currencyFormatDE(this.objStateUkupno.bottling) }}</v-flex
        >
        <v-flex
          style="
            text-align: right;
            padding-left: 0px;
            padding-right: 0px;
            width: 10%;
          "
          >{{ currencyFormatDE(this.objStateUkupno.warehouseState) }}</v-flex
        >
        <v-flex
          style="
            text-align: right;
            padding-left: 0px;
            padding-right: 10px;
            width: 10%;
          "
          >{{ currencyFormatDE(this.objStateUkupno.output) }}</v-flex
        >
        <v-flex
          style="
            text-align: right;
            padding-left: 0px;
            padding-right: 15px;
            width: 10%;
          "
          >{{ currencyFormatDE(this.objStateUkupno.writeOff) }}</v-flex
        >
        <v-flex
          style="
            text-align: right;
            padding-left: 0px;
            padding-right: 10px;
            width: 10%;
          "
          >{{ currencyFormatDE(this.objStateUkupno.selling) }}</v-flex
        >
        <v-flex
          style="
            text-align: right;
            padding-left: 0px;
            padding-right: 18px;
            width: 16%;
          "
          >{{ currencyFormatDEdec(this.objStateUkupno.sellingValue) }}</v-flex
        >
      </v-layout> -->
      <v-layout v-if="prikazi_grafik">
        <v-flex xs12>
          <!--  -->
          <MyComponentChart
            :item="graphic_data_pom"
            :ucitan_grafik="ucitaj_grafik"
            :naslov="naslov_grafik_pom"
          ></MyComponentChart>
        </v-flex>
        <v-flex
          ><button
            id="closeModalBtn"
            @click.prevent="closeGraf"
            class="v-btn v-btn--flat white"
          >
            <v-icon>close</v-icon>
          </button></v-flex
        >
      </v-layout>
    </v-container>

    <v-dialog
      v-model="dialogNote_grafik"
      scrollable
      content-class="ModalInModalMaksimalaVelicinaBerbaNovo"
      persistent
    >
      <v-container style="padding: 0px">
        <div class="DataTable">
          <div data-v-fae5bece class="v-card">
            <div
              data-v-fae5bece
              class="v-card__title headline lighten-2 v-card__title--primary"
              style="padding-left: 30px; padding-bottom: 20px"
            >
              <!-- Modal Titles  -->

              <div v-if="this.wine_item !== undefined">
                {{ this.wine_item.wineLabel.name + " " + this.wine_item.year + " - " + this.wine_item.wineLabel.bottleVolumeInLiters }}l
              </div>

              <div style="text-align: right; margin-right: 95px">
                {{ this.ukupan_iznos }} RSD
              </div>

              <button
                id="closeModalBtn"
                @click.prevent="closeModalGrafik"
                class="v-btn v-btn--flat white"
              >
                <v-icon>close</v-icon>
              </button>
            </div>

            <!-- <div data-v-fae5bece class="spacer"></div> -->
            <MyComponentGrafik
              :item="graphic_data_pom_novo"
              :naslov="naslov_grafik_pom"
              :vino="vino_pom"
            ></MyComponentGrafik>
          </div>
        </div>
        <!-- /.addingToTank -->
      </v-container>
    </v-dialog>

    <v-dialog
      v-model="dialogNote_izmena_etikete"
      scrollable
      content-class="ModalInModalSrednji"
      persistent
    >
      <v-container style="padding: 0px">
        <div class="DataTable">
          <div data-v-fae5bece class="v-card">
            <div
              data-v-fae5bece
              class="v-card__title headline lighten-2 v-card__title--primary"
              style="padding-left: 30px; padding-bottom: 0px"
            >
              <!-- Modal Titles  -->

              <div v-if="this.wine_item !== undefined">
                {{ this.wine_item.wineLabel.name + " " + this.wine_item.year }}
              </div>

              <button
                id="closeModalBtn"
                @click.prevent="closeModal"
                class="v-btn v-btn--flat white"
              >
                <v-icon>close</v-icon>
              </button>
            </div>

            <!-- <div data-v-fae5bece class="spacer"></div> -->
            <MyComponent
              @newdata="handleData($event)"
              @close="closeModal"
              :item="wine_item_pom"
            ></MyComponent>
          </div>
        </div>
        <!-- /.addingToTank -->
      </v-container>
    </v-dialog>
    <v-dialog
      v-model="dialogNote_izmena_slike"
      scrollable
      content-class="ModalInModalSrednji"
      persistent
    >
      <v-container style="padding: 0px">
        <div class="DataTable">
          <div data-v-fae5bece class="v-card">
            <div
              data-v-fae5bece
              class="v-card__title headline lighten-2 v-card__title--primary"
              style="padding-left: 30px; padding-bottom: 0px"
            >
              <!-- Modal Titles  -->

              <div v-if="this.wine_item !== undefined">
                {{ this.wine_item.wineLabel.name + " " + this.wine_item.year }}
              </div>

              <button
                id="closeModalBtn"
                @click.prevent="closeModalSlika"
                class="v-btn v-btn--flat white"
              >
                <v-icon>close</v-icon>
              </button>
            </div>

            <div data-v-fae5bece class="spacer"></div>
            <MyImageComponent
              @newdata="handleDataSlika($event)"
              @close="closeModalSlika"
              :item="wine_item_pom"
            ></MyImageComponent>
          </div>
        </div>
        <!-- /.addingToTank -->
      </v-container>
    </v-dialog>

    <TokenComponent ref="frmtoken" />
  </div>
  <!-- /.SingleVine -->
</template>

<script>
import Breadcrumbs from "../components/layoutComponents/Breadcrumbs";
import TokenComponent from "../components/Token";
import MyComponent from "../components/WineItemPomComponent.vue";
import MyComponentChart from "../components/AmrChratPie.vue";
import MyComponentGrafik from "../components/AmrChratPictorialStackedGrape.vue";

import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

import { nadjiSlikuVina, nadjiSliku } from "../helpers/Functions";
import MyImageComponent from "../components/WinePomImageComponent.vue";

// am4core.useTheme(am4themes_animated);

export default {
  name: "Vine",
  dialog: false,
  components: {
    Breadcrumbs,
    TokenComponent,
    MyComponent,
    MyComponentChart,
    MyComponentGrafik,
    Loading,
    MyImageComponent,
  },
  data() {
    return {
      administrator: undefined,
      wine_item: undefined,
      wine_item_pom: undefined,
      wine_id: 0,
      headers: [
        { text: "Lot", value: "", align: "center" },
        { text: "Tankovi", value: "", align: "center" },
        { text: "Flaširano", value: "", align: "right" },
        { text: "Na stanju", value: "", align: "right" },
        { text: "Izdato", value: "", align: "right" },
        { text: "Otpisano", value: "", align: "right" },
        { text: "Prodato", value: "", align: "right" },
        { text: "Vrednost prodaje", value: "", align: "right" },
        { text: "Funkcije", value: "", align: "right" },
      ],
      items_state: [],
      items_state_table: [],
      pagination: {
        sortBy: "lot",
        rowsPerPage: 10000000,
        descending: false,
      },
      objStateUkupno: {},

      dialogNote_izmena_etikete: false,
      dialogNote_grafik: false,
      graphic_data: [],
      graphic_data_pom: [],
      graphic_data_novo: [],
      graphic_data_pom_novo: [],
      ucitaj_grafik: undefined,
      naslov_grafik: undefined,
      naslov_grafik_pom: undefined,
      loading: true,
      fullPage: true,
      isLoading: false,
      prikazi_grafik: false,
      dialogNote_izmena_slike: false,

      cena: "0,00 RSD",
      vino_pom: true,
      ukupan_iznos: "",
      slika: "",
      slika_error: ""
    };
  },
  methods: {
    daLiJeAdmin(){
      let odgovor = false;

      let pomStr = localStorage.getItem("role");

      if(pomStr ==='admin')
        odgovor = true;

      return odgovor;
    },
    submit_parameterGrafic() {
      this.dialogNote_grafik = true;
      this.graphic_data_pom_novo = this.graphic_data_novo;
    },
    cenaKostanja() {
      this.isLoading = true;

      this.$http
        .get(
          this.globalServiceLocation +
            this.globalPort +
            "/wine/wine_bottled_costs/" +
            this.wine_id,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          if (response.data.productionPrice !== null)
            this.cena =
              this.currencyFormatDEdec(response.data.productionPrice) + " RSD";
          else this.cena = "-";

          this.isLoading = false;

          this.graphic_data_novo = [
            {
              category: "Repromaterijal",
              value:
                response.data.addingMaterialCost +
                response.data.filteringMaterialCost +
                response.data.washingMaterialCost,
            },
            {
              category: "Grožđe",
              value: response.data.grapeCost,
            },
            {
              category: "Ambalaža",
              value: response.data.packagingCost,
            },
          ];

          this.ukupan_iznos = this.currencyFormatDEdec(
            response.data.productionPrice
          );
        })
        .catch((e) => {
          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  this.$http
                    .get(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/wine/wine_bottled_costs/" +
                        this.wine_id,
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      if (response.data.productionPrice !== null)
                        this.cena =
                          this.currencyFormatDEdec(
                            response.data.productionPrice
                          ) + " RSD";
                      else this.cena = "-";

                      this.isLoading = false;

                      this.graphic_data_novo = [
                        {
                          category: "Repromaterijal",
                          value:
                            response.data.addingMaterialCost +
                            response.data.filteringMaterialCost +
                            response.data.washingMaterialCost,
                        },
                        {
                          category: "Grožđe",
                          value: response.data.grapeCost,
                        },
                        {
                          category: "Ambalaža",
                          value: response.data.packagingCost,
                        },
                      ];

                      this.ukupan_iznos = this.currencyFormatDEdec(
                        response.data.productionPrice
                      );
                    })
                    .catch((e) => {
                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                      this.isLoading = false;
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
              this.isLoading = false;
            }
          }
        });
    },
    submit_izmena_slike(e) {
      e.preventDefault();
      this.dialogNote_izmena_slike = true;

      this.wine_item_pom = this.wine_item;
    },
    handleDataSlika: function (e) {
      // this.getDataLabel();
      this.slika = "";

      this.slika = nadjiSlikuVina(this.wine_id);

      this.dialogNote_izmena_slike = false;
      this.wine_item_pom = undefined;
    },
    closeModalSlika() {
      this.slika = "";

      this.slika = nadjiSlikuVina(this.wine_id);

      this.dialogNote_izmena_slike = false;
      this.wine_item_pom = undefined;
    },
    closeGraf() {
      this.naslov_grafik = undefined;
      this.prikazi_grafik = false;
    },
    getGraficData(obj) {
      // console.log(obj);

      

      this.naslov_grafik = obj.lot;

      this.isLoading = true;
      this.prikazi_grafik = true;

      let _this = this;

      this.graphic_data = [];

      this.$http
        .post(
          this.globalServiceLocation +
            this.globalPort +
            "/wine/chart/" +
            this.wine_id +
            "/lot",
          obj.lot,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          // _this.ucitajGrafik();

          let brojRedova = response.data.length;
          let rbR = 0;
          response.data.forEach(function (entry) {
            setTimeout(() => {
              rbR = rbR + 1;

              _this.getGraficDataChildren(entry, brojRedova, rbR);
            }, 500);
          });
        })
        .catch((e) => {
          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .get(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/wine/chart/" +
                        this.wine_id +
                        "/lot",
                      complexObject,
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      this.graphic_data = response.data;
                    })
                    .catch((e) => {
                      // // console.log(e.message);
                      alert(1);
                      // alert(this.$lang.general.greskaNaServeru);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    getGraficDataChildren(entry, ukupnoRedova, rBr) {
      let _this = this;

      this.$http
        .get(
          this.globalServiceLocation +
            this.globalPort +
            "/wine/chart/" +
            entry.tankPhaseWineId,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          let pomNiz = [];
          let entryPom = {};
          response.data.forEach(function (entry1) {
            pomNiz.push(entry1);
          });

          entryPom.category = entry.category;
          entryPom.value = entry.value;

          entryPom.subData = pomNiz;

          _this.graphic_data.push(entryPom);

          if (ukupnoRedova === rBr) {
            _this.graphic_data.sort(function compareFn(a, b) {
              if (a.subData.length > b.subData.length) return -1;
              else return 0;
            });
            console.log(_this.graphic_data);

            _this.naslov_grafik_pom = _this.naslov_grafik;
            _this.ucitaj_grafik = true;
            _this.graphic_data_pom = _this.graphic_data;

            _this.isLoading = false;
          }
        })
        .catch((e) => {
          if (!e.response) {
            this.isLoading = false;
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .get(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/wine/chart/" +
                        obj.tankPhaseWineId,
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      let pomNiz = [];
                      let entryPom = {};
                      response.data.forEach(function (entry1) {
                        pomNiz.push(entry1);
                      });

                      entryPom.category = entry.category;
                      entryPom.value = entry.value;

                      entryPom.subData = pomNiz;

                      _this.graphic_data.push(entryPom);

                      if (ukupnoRedova === rBr) {
                        _this.naslov_grafik_pom = _this.naslov_grafik;
                        _this.graphic_data_pom = _this.graphic_data;
                        _this.ucitaj_grafik = true;

                        _this.isLoading = false;
                      }
                    })
                    .catch((e) => {
                      _this.isLoading = false;
                      alert(1);
                      // alert(this.$lang.general.greskaNaServeru);
                    });
                });
            } else {
              this.isLoading = false;
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },

    getDataTable() {
      this.$http
        .get(
          this.globalServiceLocation +
            this.globalPort +
            "/wine/overview/" +
            this.wine_id,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          this.items_state = response.data;
          this.items_state_table = response.data;

          let flasirano = 0;
          let prodato = 0;
          let izdato = 0;
          let otpisano = 0;
          let ostalo = 0;
          let vrednost_prodaje = 0;

          response.data.forEach(function (entry) {
            flasirano = flasirano + entry.bottling;
            prodato = prodato + entry.selling;
            izdato = izdato + entry.output;
            otpisano = otpisano + entry.writeOff;
            ostalo = ostalo + entry.warehouseState;
            vrednost_prodaje = vrednost_prodaje + entry.sellingValue;
          });

          this.objStateUkupno = {
            lot: "Ukupno:",
            Tank: [
              {
                tank: "Ukupno:",
              },
            ],
            bottling: flasirano,
            selling: prodato,
            output: izdato,
            writeOff: otpisano,
            warehouseState: ostalo,
            sellingValue: vrednost_prodaje,
          };

          this.items_state_table.push(this.objStateUkupno);
          // this.ucitajGrafik();
        })
        .catch((e) => {
          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .get(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/wine_label/overview/" +
                        this.wine_id,
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      this.items_state = response.data;
                      this.items_state_table = response.data;

                      let flasirano = 0;
                      let prodato = 0;
                      let izdato = 0;
                      let otpisano = 0;
                      let ostalo = 0;
                      let vrednost_prodaje = 0;

                      response.data.forEach(function (entry) {
                        flasirano = flasirano + entry.bottling;
                        prodato = prodato + entry.selling;
                        izdato = izdato + entry.output;
                        otpisano = otpisano + entry.writeOff;
                        ostalo = ostalo + entry.warehouseState;
                        vrednost_prodaje =
                          vrednost_prodaje + entry.sellingValue;
                      });

                      this.objStateUkupno = {
                        year: "Ukupno",
                        bottling: flasirano,
                        selling: prodato,
                        output: izdato,
                        writeOff: otpisano,
                        warehouseState: ostalo,
                        sellingValue: vrednost_prodaje,
                      };

                      this.items_state_table.push(this.objStateUkupno);

                      // this.ucitajGrafik();
                    })
                    .catch((e) => {
                      // // console.log(e.message);
                      alert(1);
                      // alert(this.$lang.general.greskaNaServeru);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    routerLinkToDetails(lokID, lokIDTank, lokActive) {
      this.$router.push({
        name: "single_tank",
        params: { id: lokID, idTank: lokIDTank, active: lokActive },
      });
    },
    formatDate(date) {
      if (typeof date !== "undefined" && date !== null) {
        let lokDate = date.split("T")[0];

        let month = lokDate.split("-")[1];
        let day = lokDate.split("-")[2];
        const year = lokDate.split("-")[0];

        return [day, month, year].join(".");
      } else return "";
    },
    currencyFormatDE(num) {
      if (num !== undefined && num !== null)
        return num
          .toFixed(0) // always two decimal digits
          .replace(".", ",") // replace decimal point character with ,
          .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.");
      // use . as a separator
      else return 0;
    },
    currencyFormatDEdec(num) {
      if (num !== undefined && num !== null)
        return num
          .toFixed(2) // always two decimal digits
          .replace(".", ",") // replace decimal point character with ,
          .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.");
      // use . as a separator
      else return 0;
    },
    getAllSifarnik() {
      this.$http
        .get(
          this.globalServiceLocation +
            this.globalPort +
            "/wine/show/" +
            this.wine_id,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          this.items_dodaci = response.data.add;
          this.items_merenja = response.data.measurement;

          this.items_tabovi = response.data.tankList;

          // this.getWineData();
        })
        .catch((e) => {
          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .get(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/wine/show/" +
                        this.wine_id,
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      this.items_dodaci = response.data.add;
                      this.items_merenja = response.data.measurement;

                      this.items_tabovi = response.data.tankList;

                      // this.getWineData();
                    })
                    .catch((e) => {
                      // // console.log(e.message);
                      alert(1);
                      // alert(this.$lang.general.greskaNaServeru);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    getWineData() {
      this.$http
        .get(
          this.globalServiceLocation +
            this.globalPort +
            "/wine/" +
            this.wine_id,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          // // console.log(response.data);

          this.wine_item = response.data;

          if(document.getElementById("wineimg").src.indexOf('wineImg.png') > 0){
            this.slika = nadjiSliku(this.wine_item.wineLabel.id);
          }
        })
        .catch((e) => {
          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .get(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/wine/" +
                        this.wine_id,
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      // // console.log(response.data);

                      this.wine_item = response.data;

                      if(document.getElementById("wineimg").src.indexOf('wineImg.png') > 0){
                        this.slika = nadjiSliku(this.wine_item.wineLabel.id);
                      }
                    })
                    .catch((e) => {
                      // // console.log(e.message);
                      alert(1);
                      // alert(this.$lang.general.greskaNaServeru);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    submit_izmena(e) {
      e.preventDefault();
      this.dialogNote_izmena_etikete = true;

      this.wine_item_pom = this.wine_item;
    },
    handleData: function (e) {
      this.getWineData();
      this.dialogNote_izmena_etikete = false;
      this.wine_item_pom = undefined;
    },
    closeModal() {
      this.dialogNote_izmena_etikete = false;
      this.wine_item_pom = undefined;
    },
    closeModalGrafik() {
      this.dialogNote_grafik = false;
      this.wine_item_pom = undefined;
      this.graphic_data_pom_novo = undefined;
    },
    changeSort(column) {
      if (column !== "funkcije")
        if (this.pagination.sortBy === column) {
          this.pagination.descending = !this.pagination.descending;
        } else {
          this.pagination.sortBy = column;
          this.pagination.descending = false;
        }
    },
    changeSortMerenja(column) {
      if (column !== "funkcije")
        if (this.paginationMerenja.sortBy === column) {
          this.paginationMerenja.descending =
            !this.paginationMerenja.descending;
        } else {
          this.paginationMerenja.sortBy = column;
          this.paginationMerenja.descending = false;
        }
    },
  },
  watch: {
    $route() {
      this.wine_id = this.$route.params.id;
      this.slika_error= this.$route.params.slika;

      this.slika = nadjiSlikuVina(this.wine_id);

      //alert(this.tankId);

      // this.getAllSifarnik();
    },
  },
  mounted() {
    this.wine_id = this.$route.params.id;
      this.slika_error= this.$route.params.slika;

      this.slika = nadjiSlikuVina(this.wine_id);

    this.getAllSifarnik();
    this.getWineData();
    this.getDataTable();

    this.administrator = this.daLiJeAdmin();
    this.cenaKostanja();
  },
};
</script>

<style scoped lang='scss'>
@import "./../assets/sass/parts/modalStyles";
@import "../assets/sass/parts/_tanksRoom.scss";
.more_info {
  color: #000;
  font-size: 14px;
  padding: 6px 14px 3px;
  margin: auto 0 auto auto;
  border-radius: 3px;
  text-align: center;
  border: solid 1px #000;
  text-decoration: none;
  // text-transform: uppercase;
  font-family: NunitoSans, sans-serif;
}

.VineBox {
  position: relative;
  width: 163px;
  height: 243px;
  border: 1px solid #e2e2e2;
  margin: 0px 10px 0px;
  transition: border 0.2s ease-in-out;

  &__Img {
    height: 206px;
    img {
      height: 100%;
      width: 100%;
      object-fit: contain;
      max-height: 200px;
    }
  }
  &__Title {
    font-size: 12px;
    font-weight: bold;
    line-height: 1;
    letter-spacing: 0;
    text-align: center;
    color: #333333;
    margin-top: 10px;
    // text-transform: uppercase;
    font-family: NunitoSans, sans-serif;
  }
}

.VineYear {
  margin-top: 20px;
  margin-bottom: 80px;
  &__Header {
    display: flex;
    padding: 4px 15px 0;
    justify-content: space-between;
    h2 {
      font-family: NunitoSans, sans-serif;
      font-size: 32px;
      letter-spacing: 0;
      font-weight: 300;
      // text-transform: uppercase;
      color: #000;
    }
    .more_info {
      color: #fff;
      border: solid 1px;
      margin-top: 6px;
    }
    &--crveno {
      background-color: #8e302f;
      h2 {
        color: #ffffff;
      }
      .more_info {
        color: #ffffff;
        border-color: #fff;
      }
    }
    &--belo {
      background-color: #fcf5e2;

      h2 {
        color: #d30031;
      }
      .more_info {
        border-color: #d30031;
      }
    }
    &--penusavo {
      background-color: #d8d5cb;

      h2 {
        color: #d30031;
      }
      .more_info {
        border-color: #d30031;
      }
    }
    &--rose {
      background-color: #ffcbc4;

      h2 {
        color: #d30031;
      }
      .more_info {
        border-color: #d30031;
      }
    }
    &--pojacano {
      background-color: #892b23;

      h2 {
        color: #ffffff;
      }
      .more_info {
        color: #ffffff;
        border-color: #fff;
      }
    }
    &--slatko {
      background-color: #fcc862;

      h2 {
        color: #d30031;
      }
      .more_info {
        border-color: #d30031;
      }
    }
  }

  &__Content {
    display: flex;
    flex-wrap: wrap;
    margin-top: 30px;
    &__Vine {
      display: flex;
      // margin-right: 30px;
      .VineBox {
        margin-right: 15px;
      }
      .VineYears {
        max-width: 120px;
        height: 100%;
        max-height: 310px;
        margin: -3px -3px -3px -3px;
        display: inline-flex;
        flex-wrap: wrap;
        flex-direction: column;
        justify-content: flex-start;
        span {
          display: block;
          width: 63px;
          height: 33px;
          padding-top: 2px;
          margin: 3px;
          // border-radius: 6px;
          // border: solid 1px #9b9b9b;
          font-family: NunitoSans, sans-serif;
          font-size: 18px;
          font-weight: bold;
          letter-spacing: 0;
          text-align: center;
          color: #000000;
        }
      }
    }
  }
}

.TankDetails {
  display: flex;
  padding: 0 10px;
  flex-direction: column;
  // border-left: 1px solid #979797;
  width: 33%;
  @include bp(_1200) {
    padding: 0 10px;
  }
  &__Item {
    > * {
      width: 30%;
      display: inline-block;
      vertical-align: middle;
    }
    margin-bottom: 4px;
    font-family: "NunitoSans", sans-serif;
    font-size: 16px;
    .label {
      width: 140px;
      letter-spacing: 0;
      color: #9b9b9b;
      margin-right: 10px;
      text-align: right;
      @include bp(_1200) {
        width: auto;
      }
    }
    .value {
      width: 50%;
      color: #000;
    }
    .maka {
      max-width: 200px;
      letter-spacing: 0;
      color: #9b9b9b;
      margin-right: 20px;
      @include bp(_1200) {
        width: auto;
      }
    }
    .kvaka {
      max-width: 45px;
      letter-spacing: 0;
      color: #9b9b9b;
      margin-right: 20px;
      @include bp(_1200) {
        width: auto;
      }
    }
  }
}

.Actions__Content {
  padding: 20px 33px 0px;
}

.columnRightVineType {
  color: #018389;
  text-decoration: underline;
}

.table.v-datatable.v-table {
  width: 50%;
}
</style>
